<template>
  <!-- Right Sidebar -->
  <div
    class="doctor-right-sidebar"
    :class="{ 'collapsed': isCollapsed }"
  >
    <!-- Toggle button (from node 720:121759) -->
    <div class="toggle-btn" @click="toggleSidebar">
      <svg
        class="toggle-icon"
        :class="{ 'rotated': !isCollapsed }"
        width="16" height="16" viewBox="0 0 16 16" fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10 12L6 8L10 4" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <!-- Logo/Header Area (only in collapsed node 720:121696) -->
    <div v-show="isCollapsed" class="sidebar-logo-area">
      <div class="logo-icon-wrapper">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.33337 16H13C14.6569 16 16 17.3431 16 19V26.6667" stroke="white" stroke-width="2"/>
          <path d="M26.6666 16L19 16C17.3431 16 16 14.6569 16 13L16 5.33333" stroke="white" stroke-width="2"/>
        </svg>
      </div>
    </div>

    <!-- Collapsed state: only icons (from node 720:121701) -->
    <div v-if="isCollapsed" class="collapsed-icons">
      <!-- Help icon (node 720-121783) -->
      <button class="icon-btn" @click="expandTo('help')" title="Помощь">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.6667 15.8337V13.3337H5.83337C4.45267 13.3337 3.33337 14.4529 3.33337 15.8337M7.33337 18.3337H14C14.9335 18.3337 15.4002 18.3337 15.7567 18.152C16.0703 17.9922 16.3253 17.7372 16.485 17.4237C16.6667 17.0672 16.6667 16.6004 16.6667 15.667V4.33366C16.6667 3.40023 16.6667 2.93353 16.485 2.57701C16.3253 2.2634 16.0703 2.00843 15.7567 1.84865C15.4002 1.66699 14.9335 1.66699 14 1.66699H7.33337C5.93324 1.66699 5.23317 1.66699 4.6984 1.93948C4.22799 2.17916 3.84554 2.56161 3.60586 3.03202C3.33337 3.56679 3.33337 4.26686 3.33337 5.66699V14.3337C3.33337 15.7338 3.33337 16.4338 3.60586 16.9687C3.84554 17.4391 4.22799 17.8215 4.6984 18.0612C5.23317 18.3337 5.93324 18.3337 7.33337 18.3337Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <!-- Notifications icon (combined bell/badge node 720-124091/121787) -->
      <button class="icon-btn" @click="expandTo('notifications')" title="Уведомления">
        <svg width="21" height="25" viewBox="0 0 21 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.6667 23.3337H8.33338M10.8334 6.66699L9.16671 6.66699M5.00004 12.5003V13.3337C5.00004 13.9849 5.00004 14.3622 5.03058 14.6584L4.2231 15.6861C3.1363 17.0693 2.5929 17.7609 2.59584 18.3421C2.5984 18.8476 2.83025 19.3246 3.22616 19.639C3.68132 20.0003 4.56086 20.0003 6.31995 20.0003L13.6801 20.0003C15.4392 20.0003 16.3188 20.0003 16.7739 19.639C17.1698 14.3246 17.4017 13.8476 17.4042 18.3421C17.4072 17.7609 16.8638 12.0693 15.777 10.6861L14.9695 14.6584C15 14.3622 15 13.9849 15 13.3337V12.5003C15 11.7262 15 11.3391 14.9487 11.0152C14.6664 9.2323 13.2681 7.834 11.4852 7.55162C11.1613 7.50033 10.7742 7.50033 10 7.50033C9.22587 7.50033 8.83879 7.50033 8.5149 7.55162C6.73201 7.834 5.33372 9.2323 5.05134 11.0152C5.00004 11.3391 5.00004 11.7262 5.00004 12.5003Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <g v-if="upcomingAppointments.length > 0">
            <rect x="8" y="1" width="12" height="12" rx="6" fill="#FA4D5E"/>
            <rect x="8" y="1" width="12" height="12" rx="6" stroke="white" stroke-width="2"/>
            <text
              x="14"
              y="10"
              font-family="'Plus Jakarta Sans', sans-serif"
              font-weight="600"
              font-size="9"
              fill="#FFF1F3"
              text-anchor="middle"
            >
              {{ upcomingAppointments.length }}
            </text>
          </g>
        </svg>
      </button>

      <!-- Info icon (node 720-121790) -->
      <button class="icon-btn" @click="expandTo('info')" title="Дополнительная информация">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.1178 2.50003C11.025 2.5 10.9302 2.5 10.8333 2.5H9.16667C6.83311 2.5 5.66634 2.5 4.77504 2.95414C3.99103 3.35361 3.35361 3.99103 2.95414 4.77504C2.5 5.66634 2.5 6.83311 2.5 9.16667V10.8333C2.5 13.1669 2.5 14.3337 2.95414 15.225C3.35361 16.009 3.99103 16.6464 4.77504 17.0459C5.66634 17.5 6.83311 17.5 9.16667 17.5H10.8333C13.1669 17.5 14.3337 17.5 15.225 17.0459C16.009 16.6464 16.6464 16.009 17.0459 15.225C17.5 14.3337 17.5 13.1669 17.5 10.8333V9.16667C17.5 9.06985 17.5 8.97504 17.5 8.88217M17.5 4.16667C17.5 5.08714 16.7538 5.83333 15.8333 5.83333C14.9129 5.83333 14.1667 5.08714 14.1667 4.16667C14.1667 3.24619 14.9129 2.5 15.8333 2.5C16.7538 2.5 17.5 3.24619 17.5 4.16667Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>

    <!-- Expanded state: full content (from node 720:124006) -->
    <div v-else class="expanded-content">
      <!-- Help card (node 720:124007) -->
      <div class="sidebar-card help-card">
        <div class="card-header">
          <div class="card-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.6667 15.8337V13.3337H5.83337C4.45267 13.3337 3.33337 14.4529 3.33337 15.8337M7.33337 18.3337H14C14.9335 18.3337 15.4002 18.3337 15.7567 18.152C16.0703 17.9922 16.3253 17.7372 16.485 17.4237C16.6667 17.0672 16.6667 16.6004 16.6667 15.667V4.33366C16.6667 3.40023 16.6667 2.93353 16.485 2.57701C16.3253 2.2634 16.0703 2.00843 15.7567 1.84865C15.4002 1.66699 14.9335 1.66699 14 1.66699H7.33337C5.93324 1.66699 5.23317 1.66699 4.6984 1.93948C4.22799 2.17916 3.84554 2.56161 3.60586 3.03202C3.33337 3.56679 3.33337 4.26686 3.33337 5.66699V14.3337C3.33337 15.7338 3.33337 16.4338 3.60586 16.9687C3.84554 17.4391 4.22799 17.8215 4.6984 18.0612C5.23317 18.3337 5.93324 18.3337 7.33337 18.3337Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span class="card-title">Помощь</span>
        </div>

        <div class="help-body">
          <p class="help-text">Чтобы начать прием нажмите на кнопку:</p>
          <div class="help-tag-row">
            <span class="help-tag light">Начать прием</span>
          </div>

          <p class="help-text">Чтобы пригласить другого специалиста нажмите на кнопку:</p>
          <div class="help-tag-row">
            <span class="help-tag purple">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 13.1974C16.2133 13.8069 17.2534 14.785 18.0127 16.008C18.163 16.2503 18.2382 16.3713 18.2642 16.539C18.317 16.8798 18.084 17.2988 17.7666 17.4337C17.6104 17.5 17.4347 17.5 17.0834 17.5M13.3334 9.61017C14.5681 8.99658 15.4167 7.72238 15.4167 6.25C15.4167 4.77762 14.5681 3.50343 13.3334 2.8898M11.6667 6.25C11.6667 8.32107 9.98769 10 7.91666 10C5.84559 10 4.16666 8.32107 4.16666 6.25C4.16666 4.17893 5.84559 2.5 7.91666 2.5C9.98769 2.5 11.6667 4.17893 11.6667 6.25ZM2.13268 15.7819C3.46127 13.7872 5.5578 12.5 7.91666 12.5C10.2755 12.5 12.372 13.7872 13.7006 15.7819C13.9917 16.219 14.1372 16.4375 14.1204 16.7166C14.1074 16.9339 13.9649 17.2 13.7913 17.3313C13.5683 17.5 13.2615 17.5 12.648 17.5H3.18529C2.5718 17.5 2.26506 17.5 2.04202 17.3313C1.86836 17.2 1.7259 16.9339 1.71285 16.7166C1.6961 16.4375 1.84162 16.219 2.13268 15.7819Z" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </div>

          <p class="help-text">в главном меню административной панели</p>
        </div>
      </div>

      <!-- Notifications card (node 720:124919) -->
      <div class="sidebar-card notif-card">
        <div class="card-header">
          <div class="card-icon">
            <svg width="21" height="25" viewBox="0 0 21 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.6667 23.3337H8.33338M10.8334 6.66699L9.16671 6.66699M5.00004 12.5003V13.3337C5.00004 13.9849 5.00004 14.3622 5.03058 14.6584L4.2231 15.6861C3.1363 17.0693 2.5929 17.7609 2.59584 18.3421C2.5984 18.8476 2.83025 19.3246 3.22616 19.639C3.68132 20.0003 4.56086 20.0003 6.31995 20.0003L13.6801 20.0003C15.4392 20.0003 16.3188 20.0003 16.7739 19.639C17.1698 14.3246 17.4017 13.8476 17.4042 18.3421C17.4072 17.7609 16.8638 12.0693 15.777 10.6861L14.9695 14.6584C15 14.3622 15 13.9849 15 13.3337V12.5003C15 11.7262 15 11.3391 14.9487 11.0152C14.6664 9.2323 13.2681 7.834 11.4852 7.55162C11.1613 7.50033 10.7742 7.50033 10 7.50033C9.22587 7.50033 8.83879 7.50033 8.5149 7.55162C6.73201 7.834 5.33372 9.2323 5.05134 11.0152C5.00004 11.3391 5.00004 11.7262 5.00004 12.5003Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
              <g v-if="upcomingAppointments.length > 0">
                <rect x="8" y="1" width="12" height="12" rx="6" fill="#FA4D5E"/>
                <rect x="8" y="1" width="12" height="12" rx="6" stroke="white" stroke-width="2"/>
                <text
                  x="14"
                  y="10"
                  font-family="'Plus Jakarta Sans', sans-serif"
                  font-weight="600"
                  font-size="9"
                  fill="#FFF1F3"
                  text-anchor="middle"
                >
                  {{ upcomingAppointments.length }}
                </text>
              </g>
            </svg>
          </div>
          <span class="card-title">Уведомление</span>
        </div>

        <div class="notif-list">
          <div
            v-if="upcomingAppointments.length === 0"
            class="notif-empty"
          >
            Нет предстоящих приёмов
          </div>
          <button
            v-for="(appt, idx) in upcomingAppointments"
            :key="appt.id || idx"
            class="notif-item"
            :class="{ 'notif-item--active': idx === 0 }"
            @click="$emit('appointment-click', appt)"
          >
            <span class="notif-item-text">{{ formatApptNotif(appt) }}<span v-if="appt.appointment_format === 'offline'"> · Офлайн</span></span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" class="notif-arrow">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
            </svg>
          </button>
        </div>
      </div>

      <!-- Additional info row (node 720:124107) -->
      <div class="info-row">
        <div class="info-row-icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.1178 2.50003C11.025 2.5 10.9302 2.5 10.8333 2.5H9.16667C6.83311 2.5 5.66634 2.5 4.77504 2.95414C3.99103 3.35361 3.35361 3.99103 2.95414 4.77504C2.5 5.66634 2.5 6.83311 2.5 9.16667V10.8333C2.5 13.1669 2.5 14.3337 2.95414 15.225C3.35361 16.009 3.99103 16.6464 4.77504 17.0459C5.66634 17.5 6.83311 17.5 9.16667 17.5H10.8333C13.1669 17.5 14.3337 17.5 15.225 17.0459C16.009 16.6464 16.6464 16.009 17.0459 15.225C17.5 14.3337 17.5 13.1669 17.5 10.8333V9.16667C17.5 9.06985 17.5 8.97504 17.5 8.88217M17.5 4.16667C17.5 5.08714 16.7538 5.83333 15.8333 5.83333C14.9129 5.83333 14.1667 5.08714 14.1667 4.16667C14.1667 3.24619 14.9129 2.5 15.8333 2.5C16.7538 2.5 17.5 3.24619 17.5 4.16667Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <span>Дополнительная информация</span>
      </div>
    </div>
  </div>
</template>

<script>
import { 
  LEFT_SIDEBAR_KEY, 
  RIGHT_SIDEBAR_KEY, 
  SIDEBAR_SYNC_EVENT,
  setSidebarCollapsedState 
} from '@/utils/sidebarSync'

export default {
  name: 'DoctorRightSidebar',
  props: {
    appointments: {
      type: Array,
      default: () => []
    }
  },
  emits: ['appointment-click', 'toggle'],
  data() {
    const saved = localStorage.getItem('doctor_right_sidebar_collapsed')
    return {
      isCollapsed: saved !== null ? saved === 'true' : false
    }
  },
  computed: {
    upcomingAppointments() {
      if (!this.appointments || this.appointments.length === 0) return []
      return this.appointments
        .filter(a => a.status === 'scheduled')
        .slice(0, 4) // Show only up to 4 nearest scheduled items
    }
  },
  methods: {
    toggleSidebar() {
      const nextCollapsed = !this.isCollapsed
      this.isCollapsed = nextCollapsed
      setSidebarCollapsedState(RIGHT_SIDEBAR_KEY, nextCollapsed)
      
      if (!nextCollapsed) {
        setSidebarCollapsedState(LEFT_SIDEBAR_KEY, true)
      }
      
      this.$emit('toggle', nextCollapsed)
    },
    handleSidebarSync(event) {
      const { key, collapsed } = event.detail || {}
      if (key === RIGHT_SIDEBAR_KEY && typeof collapsed === 'boolean') {
        this.isCollapsed = collapsed
      }
    },
    expandTo(section) {
      if (this.isCollapsed) {
        this.toggleSidebar()
      }
    },
    formatApptNotif(appt) {
      let dateStr = ''
      let timeStr = ''

      const slot = appt.slot
      if (slot && typeof slot === 'object') {
        if (slot.date) {
          const [y, m, d] = slot.date.split('-')
          dateStr = `${d}.${m}.${y}`
        }
        if (slot.start_time) {
          timeStr = slot.start_time.substring(0, 5)
        }
      } else if (appt.scheduled_time) {
        const dt = new Date(appt.scheduled_time)
        dateStr = dt.toLocaleDateString('ru-RU')
        timeStr = dt.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
      }

      if (dateStr && timeStr) return `${dateStr} | ${timeStr} Прием`
      if (timeStr) return `${timeStr} Прием`
      return 'Прием'
    }
  },
  mounted() {
    window.addEventListener(SIDEBAR_SYNC_EVENT, this.handleSidebarSync)
  },
  beforeUnmount() {
    window.removeEventListener(SIDEBAR_SYNC_EVENT, this.handleSidebarSync)
  }
}
</script>

<style scoped>
/* ===================== RIGHT SIDEBAR ===================== */
.doctor-right-sidebar {
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  background: #162538;
  z-index: 50;
  display: flex;
  flex-direction: column;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  width: 305px;
  overflow: visible;
}

.doctor-right-sidebar.collapsed {
  width: 66px;
}

/* ── Toggle button (720:121759) ── */
.toggle-btn {
  position: absolute;
  top: 108px;
  left: -14px;
  width: 28px;
  height: 28px;
  background: #162538;
  border: 1px solid white;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 60;
  transition: transform 0.2s ease;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
}

.toggle-btn:hover {
  transform: scale(1.1);
}

.toggle-icon {
  transition: transform 0.3s ease;
  color: white;
}

.toggle-icon.rotated {
  transform: rotate(180deg);
}

/* ── Logo Area (720:121696) ── */
.sidebar-logo-area {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.logo-icon-wrapper {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ── Collapsed icons (720:121701) ── */
.collapsed-icons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  padding: 66.5px 11px 0;
  width: 100%;
}

.icon-btn {
  position: relative;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  border: none;
  background: transparent;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.icon-btn:hover {
  background: rgba(255, 255, 255, 0.05);
  color: white;
}

.notif-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 10px;
  height: 10px;
  background: #fa4d5e;
  border: 2px solid white;
  border-radius: 13px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 600;
  font-size: 10px;
  color: #fff1f3;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: normal;
  letter-spacing: 1px;
  transform: translate(50%, -50%);
}

/* ── Expanded content (720:124006) ── */
.expanded-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 56px 20px 20px; /* starts at y=56 */
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.expanded-content::-webkit-scrollbar { width: 0; }

/* ── Card ── */
.sidebar-card {
  background: #0066ff;
  border-radius: 12px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  width: 265px; /* metadata: width=265.012 */
  flex-shrink: 0;
}

.help-card {
  height: 325px;
}

.notif-card {
  height: 224px;
}

/* ── Card header ── */
.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 41px;
  border-bottom: 0.5px solid white;
  margin-bottom: 12px;
}

.card-icon {
  position: relative;
  width: 20px;
  height: 20px;
  color: white;
}

.card-title {
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 300;
  color: white;
  line-height: 20px;
}

/* ── Help card body ── */
.help-body {
  display: flex;
  flex-direction: column;
}

.help-text {
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 300;
  color: white;
  line-height: 20px;
  margin-bottom: 12px;
}

.help-tag-row {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.help-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  border-radius: 8px;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 20px;
}

.help-tag.light {
  background: #c6ecd5;
  color: #131316;
  padding: 4px 16px;
}

.help-tag.purple {
  background: #cb30e0;
  color: white;
  width: 28px;
  padding: 0;
}

/* ── Notifications card ── */
.notif-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.notif-empty {
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  color: rgba(255,255,255,0.8);
  text-align: center;
  padding-top: 10px;
}

.notif-item {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 28px;
  padding: 4px 16px;
  border-radius: 8px;
  background: #162538;
  border: none;
  cursor: pointer;
  width: 100%;
}

.notif-item--active {
  background: #dc3e42;
}

.notif-item-text {
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 300;
  color: white;
  line-height: 20px;
  flex: 1;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notif-arrow {
  color: white;
  flex-shrink: 0;
}

/* ── Info row ── */
.info-row {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 64px;
  padding: 12px;
  border-bottom: 0.5px solid white; /* design context says border-b */
  color: white;
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 300;
  margin-top: 12px;
}

.info-row-icon {
  width: 20px;
  height: 20px;
}
</style>
